export default __webpack_public_path__ + "static/media/witch.5db180cd.gif";